import {DrawerProps} from '@mantine/core';
import {CreateForm} from '../forms/CreateForm.tsx';
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        opened,
        onClose,
        ...rest
    }: DrawerProps) => {

    const title = 'Add Provider Mapping';

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <CreateForm onSuccess={onClose}/>
        </PlatformDrawer>
    )
};
